export interface DashletWithAiBlock {
  config?: {
    feExtraInfo?: {
      aiBlock?: { conversationId?: string; forkedFrom?: string } | null;
      [key: string]: unknown;
    } | null;
    [key: string]: unknown;
  } | null;
  [key: string]: unknown;
}

export const getDashletConversationId = (
  dashlet: DashletWithAiBlock | null | undefined
): string | null =>
  dashlet?.config?.feExtraInfo?.aiBlock?.conversationId ?? null;

/** The source conversation of a duplicated block that has no conversation of its own yet. */
export const getDashletForkedFrom = (
  dashlet: DashletWithAiBlock | null | undefined
): string | null => dashlet?.config?.feExtraInfo?.aiBlock?.forkedFrom ?? null;

export const isAiBlockDashlet = (
  dashlet: DashletWithAiBlock | null | undefined
): boolean =>
  getDashletConversationId(dashlet) !== null ||
  getDashletForkedFrom(dashlet) !== null;

/** The marker a duplicate of `source` carries, in the server's snake_case shape. */
export const buildDuplicateAiBlockMarker = (
  source: DashletWithAiBlock | null | undefined
): { ai_block: { forked_from: string } } | Record<string, never> => {
  // A copy of a copy that never started its own conversation forks the same original.
  const forkFrom =
    getDashletConversationId(source) ?? getDashletForkedFrom(source);
  return forkFrom ? { ai_block: { forked_from: forkFrom } } : {};
};
